import React, { useMemo } from 'react';
import classNames from 'classnames';

import { ButtonMenu } from '../../../../components/actions/ButtonMenu';
import { ContainerListItem } from 'components/actions/ListItem/ListItem.view';
import { SquareButtonIconsEnum } from 'constants/square-button-icons';
import { Button } from 'components/actions/Button';
import { ButtonColorsEnum } from 'constants/button-colors';

import classes from './SnippetCard.module.scss';
import { Debugger } from '../../../../components/containers/Debugger';

export type SnippetCardViewProps = {
  id: string;
  name: string;
  content: string;
  shouldAddDots: boolean;
  onAddToPostClick?: (shouldAddDots: boolean, content: string, id: string) => void;
  onEditClick: (id: string) => void;
  onDeleteClick: (id: string) => void;
};

export const SnippetCardView = (props: SnippetCardViewProps): JSX.Element => {
  const { id, name, content, onAddToPostClick, onEditClick, onDeleteClick, shouldAddDots } = props;
  const listItems: ContainerListItem[] = useMemo(
    () => [
      {
        action: () => onEditClick(id),
        label: 'Edit Snippet'
      },
      {
        action: () => onDeleteClick(id),
        label: 'Delete Snippet'
      }
    ],
    [onEditClick, onDeleteClick, id]
  );

  return (
    <div className={classNames('cell auto grid-y align-justify', classes.SnippetCard)}>
      <div className={'relative'}>
        <Debugger tooltipContent={'Snippet ID: ' + props.id} modalContent={props} />
      </div>
      <div
        className={classNames(
          'grid-x cell align-justify align-middle padding-top-small-2 padding-bottom-small-2 margin-bottom-small-16',
          classes.SnippetCardNameWrapper
        )}>
        <h4 className={classNames('cell auto', classes.SnippetCardSpacer)}>{name}</h4>

        <div className={'grid-x align-middle'}>
          {!!onAddToPostClick && (
            <Button
              variant={'solid'}
              action={() => onAddToPostClick(shouldAddDots, content, id)}
              type={'button'}
              size={'small'}
              color={ButtonColorsEnum.primary}>
              <span className={'uppercase'}>Add To Post</span>
            </Button>
          )}
          <ButtonMenu
            buttonType={'transparent'}
            listItems={listItems}
            side={'right'}
            icon={SquareButtonIconsEnum.dots}
            isSquareButton={true}
          />
        </div>
      </div>

      <p className={classNames('cell auto', classes.SnippetCardSpacer, classes.SnippetCardContent)}>{content}</p>
    </div>
  );
};
